"use client";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Flex, Spacer, Text, useBreakpointValue } from "@chakra-ui/react";
import { Display } from "./SectionTitle.types";
const afterStyle = {
    content: `""`,
    width: "0%",
    height: "0px",
    borderTopColor: "transparent",
    borderRightColor: "transparent",
    borderBottomColor: "transparent",
    borderLeftColor: "semantic.brand.tertiary",
    position: "absolute",
    top: "calc(50% - 0.75rem)",
    left: "0",
    borderStyle: "solid",
    borderWidth: "0.75rem 0 0.75rem 0.75rem",
};
const SectionTitle = ({ description, children, marginBottom, mb, marginTop, mt, title, }) => {
    const display = useBreakpointValue({
        sm: Display.mobile,
        md: Display.desktop,
    }, {
        fallback: "md",
    });
    return (_jsxs(_Fragment, { children: [children ? (_jsxs(Flex, Object.assign({ align: "center", gap: 2, background: "semantic.brand.tertiary-dimmed", position: "relative", mb: marginBottom !== null && marginBottom !== void 0 ? marginBottom : mb, mt: marginTop !== null && marginTop !== void 0 ? marginTop : mt, pl: 7, pr: 4, py: 2, _after: afterStyle }, { children: [_jsx(Text, Object.assign({ as: "h3", variant: display === Display.desktop
                            ? "title.desktopSection"
                            : "title.mobileSection" }, { children: title })), _jsx(Spacer, {}), children] }))) : (_jsx(Text, Object.assign({ as: "h3", variant: display === Display.desktop
                    ? "title.desktopSection"
                    : "title.mobileSection", background: "semantic.brand.tertiary-dimmed", mb: marginBottom !== null && marginBottom !== void 0 ? marginBottom : mb, mt: marginTop !== null && marginTop !== void 0 ? marginTop : mt, pl: 7, pr: 4, py: 2, position: "relative", _after: afterStyle }, { children: title }))), description && (_jsx(Text, Object.assign({ mt: "1", variant: "subtitle.section", color: "semantic.text.tertiary" }, { children: description })))] }));
};
export default SectionTitle;
//# sourceMappingURL=SectionTitle.js.map